<template>
    <div class="new_post">
        <form class="forms-sample">
            <h5 class=" sub-title mb-3 text-primary">{{ formHeader }}</h5>

            <div class="form-group row">
                <!-- title input -->
                <div class="col-md-6">
                    <label class="label-form" for="title">Document Title:</label>
                    <input type="text" class="form-control" id="title" v-model="postForm.title" placeholder="Enter Title of the Document">
                </div>

                <!-- caption input -->
                <div class="col-md-6">
                    <label class="label-form">Upload Document Here:</label>
                    <div class="form-control" style="padding:6px">
                        <input type="file" ref="caption" @change="handleCaptionUpload()">
                    </div>
                </div>
            </div>

            <br />

            <div class="text-right">
                <button class="btn btn-primary" @click.prevent="uploadDocument">Submit</button>
            </div>

            <hr />
            <h6>Organization Documents</h6>
            <br>
            <div class="card" v-for="doc in orgDocs">
                <img src="/doc.png" alt="Avatar" style="width:100%">
                <p class="text-center">{{doc.document_title.substr(0,20)}}</p>
                <div class="container">
                    <button type="button" @click="downloadDocument(doc)" class="btn btn-primary btn-sm download-btn">Download</button>
                    <button type="button" class="btn btn-warning text-dark btn-sm delete-btn" @click="deleteDocument(doc)">Delete</button>
                </div>
            </div>
            <div v-if="orgDocs.length === 0">
                <h6 class="text-center">No Documents Found in this Organization</h6>
            </div>

        </form>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        data: function () {
            return {
                formHeader: '',
                postForm: {},
                orgDocs: {}
            };
        },

        created: function () {
            // Upon page creation setting data like org_id etc
            this.formHeader = 'Add Document to Organization';
            this.postForm.organization_id = this.$route.params.organization_id;

            this.getAllDocs();
        },

        methods: {
            // Getting Documents of current organization
            getAllDocs() {
                axios.get('admin/organization/document/' + this.postForm.organization_id)
                    .then((response) => {
                        this.orgDocs = response.data.organization;
                    });
            },

            // Setting image in postFrom when uploaded.
            handleCaptionUpload() {
                this.postForm.caption = this.$refs.caption.files[0];
            },

            // Upload Document against an organization
            uploadDocument() {
                // Show warning message if Title or document is not given
                if (this.postForm.title === ''
                    || this.postForm.caption === ''
                    || this.postForm.title === undefined
                    || this.postForm.caption === undefined
                ) {
                    this.$toast.warning('Please Enter Title and Upload Image to Proceed');
                } else {
                    let formData = new FormData();
                    formData.append('title', this.postForm.title);
                    formData.append('organization_id', this.postForm.organization_id);
                    formData.append('caption', this.postForm.caption);

                    axios.post('/admin/organization/document', formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                        .then((org) => {
                            if(org.data.status==422){
                                this.$toast.warning(org.data.message);

                            }
                            // send successful message
                            if(org.data.status!=422){
                                this.$toast.success(`Document has been added successfully`);
                            // reset post
                            this.postForm.title = '';
                            this.postForm.caption = '';
                            this.getAllDocs();
                            }
                            
                        })
                        .catch((error) => {
                            let response = error.response;
                            // send error message
                            this.$toast.error(response.data.message.title[0]);
                        });
                }
            },

            // get mimeType from file extension for passing blob object
            getMimetype(fileExtension) {
                switch (fileExtension) {
                    case 'png':
                        return 'image/png';
                    case 'gif':
                        return 'image/gif';
                    case 'pdf':
                        return 'application/pdf';
                    case 'jpg':
                        return 'image/jpeg';
                    case 'xls':
                    case 'xlt':
                    case 'xla':
                        return 'application/vnd.ms-excel';
                    case 'doc':
                        return 'application/msword';
                    case 'docx':
                    case 'dotx':
                        return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
                }
            },
            // Download Document
            downloadDocument(doc) {
                axios.post('/admin/organization/document/download', doc, { responseType: 'arraybuffer' })
                    .then((response) => {
                        // Extract File extension so its related mimeType can be given while creating blob
                        var fileExt = doc.slug.split('.').pop();
                        let mimeType = this.getMimetype(fileExt);

                        // It is necessary to create a new blob object with mime-type explicitly set
                        var newBlob = new Blob([response.data], { type: mimeType });
                        const data = window.URL.createObjectURL(newBlob);
                        var link = document.createElement('a');
                        link.href = data;
                        link.download = doc.document_title;
                        link.click();

                        // Downloading File here
                        setTimeout(function () {
                            window.URL.revokeObjectURL(data)
                        }, 500)
                    })
                    .catch((error) => {
                        // send error message
                        this.$toast.error(error.response.data.message);
                    });
            },

            deleteDocument(doc) {
                this.$store.dispatch('message/update', {
                    title: doc.document_title,
                    body: 'Are you sure you want to delete this Document?',
                    class: 'danger',
                    confirm: true
                });

                this.$bus.$off('proceed');
                this.$bus.$once('proceed', () => {
                    this.delete(doc);
                    this.$store.dispatch('message/close');
                });
            },

            delete(document) {
                axios.post('/admin/organization/document/delete', document)
                    .then((message) => {
                        // send successful message
                        this.$toast.success(message.data.message);
                        this.getAllDocs();
                    })
                    .catch((error) => {
                        // send error message
                        this.$toast.error(error.response.data.message);
                    });
            }
        }
    }
</script>
<style scoped>
    .card {
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
        transition: 0.3s;
        width: 19%;
        border-radius: 5px;
        display: inline-block;
        margin-left: 5px;
    }

    .card:hover {
        box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
    }

    img {
        border-radius: 5px 5px 0 0;
    }

    .container {
        padding: 2px 16px;
        text-align: center;
    }

    .download-btn {
        border-bottom-right-radius: 0;
        border-top-right-radius: 0;
    }

    .delete-btn {
        border-bottom-left-radius: 0;
        border-top-left-radius: 0;
    }
</style>